import { Row, Col } from "react-bootstrap";
const Footer = () => {
  return (
    <>
      <div className="" style={{ marginTop: "35rem", width: "70%" }}>
        <Row className="d-flex  px-5">
          <Col lg={3} md={12}>
            <h4
              style={{ color: "var(--text-color)" }}
              className="text-secondary"
            >
              Email
            </h4>
            <p style={{ color: "var(--text-color)" }} className="">
              pillashivakrishna6@gmail.com
            </p>
          </Col>

          <Col lg={3} md={12}>
            <h4
              style={{ color: "var(--text-color)" }}
              className="text-secondary"
            >
              Phone
            </h4>
            <p style={{ color: "var(--text-color)" }}>7386898469</p>
          </Col>
          <Col lg={3} md={12}>
            <h4
              style={{ color: "var(--text-color)" }}
              className="text-secondary"
            >
              Location
            </h4>
            <p style={{ color: "var(--text-color)" }}>Kakinada | INDIA</p>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default Footer;
